/**
 * Code taken from rei/metrics implementation. Needed to hash user email on behalf of marketing.
 * {@link https://gitlab.com/rei/internal/product-engineering/analytics-experimentation/rei-metrics/-/blob/master/src/lib/data-methods.mts?ref_type=heads#L73 }
 *
 * @param text String to hash
 * @return {Promise<null|string>}
 */
export const sha256 = async (text) => {
  if (text) {
    const msgBuffer = new TextEncoder().encode(text);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  }
  return null;
};
